import React, { useContext } from "react";
import { Trash2 } from "lucide-react";
import AppContext from "../../context/AppContext";
import translations from "../../components/common/Translations";
import CommonButton from "../../components/common/CommonButton";
import ModalCloseButton from "../../components/common/ModalCloseButton";
import ActionIconButton from "../../components/common/ActionIconButton";
import { isRTL } from "../../utils/rtl";
const translation = {
  en: {
    create:"Create Validation",
    code:"Validation Code",
    msg:"Error Message",
    cancle:"Cancel",
    add:"Add"
  },
  ar: {
    create:"إنشاء التحقق من الصحة",
    code:"رمز التحقق",
    msg:"رسالة خطأ",
    cancle:"يلغي",
    add:"يضيف"
  },
};
const ValidationModal = ({
  onCloseValidation,
  handleCreateValidation,
  currentValidation,
  setCurrentValidation,
  validationFormValues,
  setValidationFormValues,
  previewKey,
  handleValidationDelete,
}) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentValidation((prev) => ({ ...prev, [name]: value }));
  };
  const filteredValidations = validationFormValues.filter(
    (input) => input.uniqueKey === previewKey
  );

  const { theme , langMode} = useContext(AppContext);
  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
      <div
        dir={isRTL(langMode) ? "rtl" : "ltr"}
        className={`bg-white rounded-lg p-6 relative max-w-lg w-full overflow-y-auto h-[300px]  ${
          theme === "dark"
            ? "dark-mode border"
            : theme === "high-contrast"
            ? "high-contrast"
            : ""
        }`}
      >
        <ModalCloseButton
          className={`absolute top-2 ${isRTL(langMode) ? "left-2" : "right-2"}`}
          onClick={onCloseValidation}
        />
        <form onSubmit={handleCreateValidation}>
          <h2 className="text-md font-semibold mb-4"> {translation[langMode].create}</h2>
          <div className="space-y-4">
            <div>
              <label
                htmlFor="validationCode"
                className={` ${
                  theme === "dark"
                    ? "dark-mode "
                    : theme === "high-contrast"
                    ? "high-contrast"
                    : ""
                }block text-sm font-medium text-gray-700`}
              >
                 {translation[langMode].code}
              </label>
              <input
                id="validationCode"
                name="validationCode"
                value={currentValidation.validationCode}
                onChange={handleChange}
                className={`w-full border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5 focus:ring-blue-500 
                  focus:border-blue-500  ${
                    theme === "dark"
                      ? "dark-mode "
                      : theme === "high-contrast"
                      ? "high-contrast"
                      : ""
                  }`}
              />
            </div>
            <div>
              <label
                htmlFor="errorMessage"
                className={`block text-sm font-medium text-gray-700  ${
                  theme === "dark"
                    ? "dark-mode "
                    : theme === "high-contrast"
                    ? "high-contrast"
                    : ""
                }`}
              >
                 {translation[langMode].msg}
              </label>
              <input
                id="errorMessage"
                name="errorMessage"
                value={currentValidation.errorMessage}
                onChange={handleChange}
                className={`w-full border border-gray-300 text-gray-900 text-sm rounded-lg p-2.5
                   focus:ring-blue-500 focus:border-blue-500  ${
                     theme === "dark"
                       ? "dark-mode "
                       : theme === "high-contrast"
                       ? "high-contrast"
                       : ""
                   }`}
              />
            </div>
            <div className="flex justify-end items-center gap-3">
              <CommonButton colorIntent="danger"
                type="button"
                onClick={onCloseValidation}
                variant="danger"
                tooltipText={translations[langMode].closewithoutsavingchnages}
                tooltipPosition="top"
              >
                {translation[langMode].cancle}
              </CommonButton>
              <CommonButton colorIntent="success"
                type="submit"
                variant="success"
                tooltipPosition="left"
                tooltipText={translations[langMode].addnewvalidation}
              >
                {translation[langMode].add}
              </CommonButton>
            </div>
          </div>
        </form>
        {filteredValidations.length > 0 && (
          <div className="">
            <h3 className="text-md font-bold mb-2">{translations[langMode].addedvalidation}</h3>
            {filteredValidations.map((input) => (
              <div
                key={input.validationId}
                className="flex items-center justify-between p-2 border-b border-gray-200"
              >
                <div>
                  <p className="text-sm font-semibold">
                    {translations[langMode].validationcode}: {input.validationCode}
                  </p>
                  <p className="text-sm">Error Message: {input.errorMessage}</p>
                </div>
                <ActionIconButton
                  tone="red"
                  ariaLabel={translations[langMode].deletevalidation}
                  tooltipText={translations[langMode].deletevalidation}
                  tooltipPosition="left"
                  onClick={() =>
                    handleValidationDelete(
                      input.validationId,
                      input.uniqueKey,
                      input.id
                    )
                  }
                >
                  <Trash2 size={18} />
                </ActionIconButton>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ValidationModal;
